import * as React from "react"
import { graphql, Link } from "gatsby"

import Seo from "../components/seo"
import { navigate } from "gatsby"


import "../styles/styles.css"

const Index = ({ data, pageContext }) => {
  return (
    <div className="page-container">
      <Seo title="剁手淘猫" description="旗舰店大全"/>
      <div className="header-container">
        <div className="title-container">{`旗舰店大全`}</div>
      </div>
      <div className="index-shop-container">
        {data.allMysqlShop.edges.map((item, i) => (
          <Link to={`shop/${item.node.mysqlId}/`}>
          <div className="index-shop-item-container" key={i}>
            <img
              className="index-shop-item-image"
              src={item.node.image_url}
              alt="shop avatar"
            />
            <div className="index-shop-item-title"><Link to={`shop/${item.node.mysqlId}/`}>{item.node.name}</Link></div>
          </div>
          </Link>
        ))}
      </div>
      <div className="footer-container">
        <div className="footer-copyright">
          剁手淘猫舰店铺品牌指南为您提供可以信赖的产品旗舰店铺推荐服务，为网友购买决策提供推荐品牌店铺的导购服务网站！
        </div>
        <div className="footer-copyright">
          剁手淘猫版权所有 京ICP备08013774`号 © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  )
}

export default Index

export const data = graphql`
  query {
    allMysqlShop {
      edges {
        node {
          mysqlId
          name
          description
          image_url
        }
      }
    }
  }
`
